import { DefaultState, TableFilters } from 'store/reducers/types';

export const READ_COMMENT_REPORT_FILTERS_REQUEST = 'READ_COMMENT_REPORT_FILTERS_REQUEST';
export const READ_COMMENT_REPORT_FILTERS_SUCCESS = 'READ_COMMENT_REPORT_FILTERS_SUCCESS';
export const READ_COMMENT_REPORT_FILTERS_FAILURE = 'READ_COMMENT_REPORT_FILTERS_FAILURE';

export type CommentReportFiltersState = DefaultState & {
  contents?: TableFilters;
};

interface ReadCommentReportFiltersRequest {
  type: typeof READ_COMMENT_REPORT_FILTERS_REQUEST;
};

interface ReadCommentReportFiltersSuccess {
  type: typeof READ_COMMENT_REPORT_FILTERS_SUCCESS,
  contents: TableFilters;
};

interface ReadCommentReportFiltersFailure {
  type: typeof READ_COMMENT_REPORT_FILTERS_FAILURE;
};

export type CommentReportFiltersActionTypes = ReadCommentReportFiltersRequest | ReadCommentReportFiltersSuccess | ReadCommentReportFiltersFailure;